import { Condition, ConditionUpdateInput, ConditionCreateInput } from 'shared/types/graphql';
import { createHash } from 'crypto';
import { canonicalize } from 'json-canonicalize';

export function hashCondition(
  condition: Omit<ConditionCreateInput | ConditionUpdateInput | Condition, 'checksum'>,
): string {
  return createHash('sha256')
    .update([condition.attribute, condition.operator, canonicalize(condition.operand)].join(':'))
    .digest('hex');
}
